import script from "./LanguageItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageItem.vue?vue&type=script&setup=true&lang=js"

import "./LanguageItem.vue?vue&type=style&index=0&id=dbc28902&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbc28902"]])

export default __exports__